<template>
  <v-form v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container md="12">
      <v-row dense>
        <v-col cols="12" sm="10" md="10" v-show="queryObject.reportType == null"> 
          <v-select :items="getCodeDateUtil('ReportSystem')" label="報表類型" dense clearable class="font-weight-normal" v-model="queryObject.reportType" :rules="requiredRules"></v-select>
        </v-col>
        <v-col cols="12" sm="12" md="12" v-show="queryObject.reportType != null"> 
          <v-select :items="getCodeDateUtil('ReportSystem')" label="報表類型" dense clearable class="font-weight-normal" v-model="queryObject.reportType" ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6" md="6" v-if="queryObject.reportType == 'A'">
          <v-select :items="getCodeDateUtil('accountType')" label="使用者類別" dense clearable class="font-weight-normal"  v-model="queryObject.type"  :rules="requiredRules"></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="6"  v-show="queryObject.reportType == 'C'">
          <v-select
            :items="districtArray1"
            item-text="name"
            item-value="id"
            label="服務地點"
            dense
            clearable
            v-model="queryObject.serviceCity"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="6"  v-show="queryObject.reportType == 'C'">
          <v-select
            :items="getCodeDateUtil('lang')"
            label="查詢語言別"
            dense
            clearable
            v-model="queryObject.serviceLanguage"
          ></v-select>       
        </v-col>
        <v-col cols="12" sm="6" md="6"  v-show="queryObject.reportType == 'B'||queryObject.reportType == 'C'">
          <v-dialog
            ref="dialog2"
            v-model="selectDate2"
            :return-value.sync="dates2"
            persistent
            width="290px" >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateRangeText2"
                @click:clear="dates2=[];"
                label="統計區間"
                readonly
                v-on="on"
                dense
                clearable ></v-text-field>
            </template>
            <v-date-picker
              v-model="dates2"
              locale="zh-tw"
              style="font-family:Microsoft JhengHei;"
              color="red"
              scrollable
              range >
              <v-spacer></v-spacer>
              <v-btn color="grey lighten-3" style="color:black;" @click="selectDate2 = false">取消</v-btn>
              <v-btn color="red" style="color:white;"  class="ma-2" @click="$refs.dialog2.save(dates2);" >確定</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="6" md="6"  v-show="queryObject.reportType == 'B'">
          <v-select :items="getCodeDateUtil('caseStatus')" label="案件進度" dense clearable  v-model="queryObject.status" ></v-select>
        </v-col>
      </v-row>
      <div style="float:right;">
        <v-btn color="red" style="color:white;" :disabled="(!valid)  " @click.prevent="downloadReport();">EXCEL下載</v-btn>
      </div>
    </v-container>
  </v-form>
</template>
<script>
// import InterpreterDetail from "../Common/InterpreterDetail";
import { mapGetters, mapActions } from "vuex";
import { Checkbox } from "element-ui";

export default {
  components: {
     [Checkbox.name]: Checkbox
  },
  computed: {
    ...mapActions([
    ]),
    ...mapGetters({
      idbServerUrl: ["getIdbServerUrl"]
    }),
    dateRangeText2 () {
      console.log("dates2: " + this.isNotBlankUtil(this.dates2))
      if (this.isNotBlankUtil(this.dates2))
      {
        return this.dates2.join(' ~ ')
      } else {
        return ""
      }
    },
  },
  data() {
    return {
      districtArray1: this.getCodeDateUtil("district"),
      requiredRules: [v => !!v || "此欄位是必填"],
      
      dates2:[],
      selectDate2: false,
      dialog2: false,

      valid: false,
      

      items: [],
      queryObject: {},
      

    };
  },
  watch: {
  },
  methods: {
    ...mapActions(["updateTargetCaseId"]),
    

     downloadReport() {
      var vm = this;
      let queryReportTypeString = vm.queryObject.reportType;
      let queryTypeString = vm.queryObject.type;
      let queryStatusString = vm.queryObject.status;
      let queryCityString = vm.queryObject.serviceCity;
      let queryLanguangeString = vm.queryObject.serviceLanguage;
      if (typeof vm.queryObject.reportType === "undefined") {
        queryReportTypeString = "";
      } 
      if (typeof vm.queryObject.type === "undefined") {
        queryTypeString = "";
      } 
      if (typeof vm.queryObject.status === "undefined") {
        queryStatusString = "";
      }
      if (typeof vm.queryObject.serviceCity === "undefined") {
        queryCityString = "";
      } 
      if (typeof vm.queryObject.serviceLanguage === "undefined") {
        queryLanguangeString = "";
      } 
      var ds ="";
      var de ="";
       var timeAll = [];
          if(this.dateRangeText2 !=null){
           timeAll =  this.dateRangeText2.split("~")
          for(let b=0;b<timeAll.length;b++){
            if(b==0){
              ds=timeAll[b];
            }else if(b==1){
              de=timeAll[b];
            }
          }
        }

       window.open(
              vm.idbServerUrl + "idb/ReportSystemServlet?" + "reportType="+queryReportTypeString+ "&accountType="+queryTypeString+ "&caseStatus="+queryStatusString+"&dateS="+ds+"&dateE="+de+"&serviceCity="+queryCityString+"&serviceLanguage="+queryLanguangeString
       );
      
    },

    

    
  
  },
  mounted() {
      var vm = this;
      vm.districtObjectUtil(vm.queryObject.serviceCity);
  }
};
</script>




